import { PropsWithChildren } from 'react'

export const Root = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div className="flex flex-row items-stretch flex-grow h-11 w-full p-1 border border-neutral-100 rounded-3xl font-medium text-lg">
      {children}
    </div>
  )
}
